import React from 'react';
import { Layout,Table,Typography,Card,Form,Button,DatePicker,Select,Row,Col,Modal,message,Tag} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';

import ClientHeader from '../components/header';
import ClientFooter from '../components/footer';
import ClientSider from '../components/sider';

import {
  fetchUser,
  fetchSubscriptionPlanOption,
  resendVisibilityApply
} from '../store/userAction';

const { Content } = Layout;
const { Title } = Typography;
const { RangePicker } = DatePicker;

class UserList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      resendModalVisible: false,
      resendRecord: null,
      resendLoading: false,
    };
  }

  formRef = React.createRef(); 

  componentDidMount() {
    this.handleFormChange({});
    this.props.fetchSubscriptionPlanOption();
  }

  handleFormChange=(formData)=>{
    // 需要格式化的欄位
    const dateFields = ['createdAt', 'expiresAt'];
    const formattedDates ={};
    dateFields.forEach((key) => {
      if (formData[key]) {
        formattedDates[key+'Start'] = formData[key]?.[0]?.format('YYYY-MM-DD');
        formattedDates[key+'End'] = formData[key]?.[1]?.format('YYYY-MM-DD');
      }
    });
    this.props.fetchUser({
      ...formattedDates,
      productCode:formData.productCode
    });
  }

  handleFormReset=()=>{
    this.formRef.current.resetFields();
  }

  handleResendClick = (record) => {
    this.setState({ resendModalVisible: true, resendRecord: record });
  }

  handleResendConfirm = async () => {
    const { resendRecord } = this.state;
    this.setState({ resendLoading: true });
    try {
      await this.props.resendVisibilityApply(resendRecord.productId);
      message.success('Resend submitted successfully');
      this.setState({ resendModalVisible: false, resendRecord: null });
      this.handleFormChange(this.formRef.current.getFieldsValue());
    } catch (error) {
      message.error(error.response?.data || 'Resend failed');
    } finally {
      this.setState({ resendLoading: false });
    }
  }

  handleResendCancel = () => {
    this.setState({ resendModalVisible: false, resendRecord: null });
  }

  getVisibilityTag = (record) => {
    const { visibilityStatus, visibilityChangeStatus, visibilityChangeReason } = record;
    if (!visibilityStatus) return <span>-</span>;

    const changeStatusMap = {
      SUCCEEDED: { color: 'success',    label: 'Succeeded' },
      APPLYING:  { color: 'processing', label: 'Applying' },
      PREPARING: { color: 'processing', label: 'Preparing' },
      FAILED:    { color: 'error',      label: 'Failed' },
      CANCELLED: { color: 'default',    label: 'Cancelled' },
    };

    const visibilityTag = <Tag color={visibilityStatus === 'Public' ? 'green' : 'orange'}>{visibilityStatus}</Tag>;

    if (!visibilityChangeStatus) return visibilityTag;

    const config = changeStatusMap[visibilityChangeStatus] || { color: 'default', label: visibilityChangeStatus };
    const changeTag = <Tag color={config.color}>{config.label}</Tag>;

    if (visibilityChangeStatus === 'FAILED') {
      return (
        <span>
          {visibilityTag} - {changeTag}
          {visibilityChangeReason && <span style={{ color: '#ff4d4f', marginLeft: 4 }}>- {visibilityChangeReason}</span>}
        </span>
      );
    }

    return <span>{visibilityTag} - {changeTag}</span>;
  }

  render() {
    const columns = [
      {
        title: 'AWS Customer ID',
        dataIndex: 'awsAccountId',
        key: 'awsAccountId',
        sorter: (a, b) => a.awsAccountId - b.awsAccountId,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: 'Subscription Plan',
        dataIndex: 'dimension',
        key: 'dimension',
      },
      {
        title: 'Visibility Status',
        dataIndex: 'visibilityChangeStatus',
        key: 'visibilityChangeStatus',
        align: 'center',
        render: (_, record) => this.getVisibilityTag(record),
      },
      {
        title: 'Expiration',
        dataIndex: 'expired',
        key: 'expired',
        align:'center',
        render: (_, record) => (
          <span
            style={{
              color: record.expired === 'Y' ? 'green' : 'red',
              fontWeight: 'bold'
            }}
          >
            {record.expired === 'Y' ? 'Expired' : 'Not Expired'}
          </span>
        )
      },
      {
        title: 'Subscription Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      },
      {
        title: 'Expires Date',
        dataIndex: 'expiresAt',
        key: 'expiresAt',
        sorter: (a, b) => new Date(a.expiresAt) - new Date(b.expiresAt)
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (_, record) => {
          const s = record.visibilityChangeStatus;
          const hidden = s === 'PREPARING' || s === 'APPLYING' || s === 'SUCCEEDED';
          if (hidden) return null;
          const { resendLoading, resendModalVisible, resendRecord } = this.state;
          const isProcessing = (resendModalVisible || resendLoading) && resendRecord?.productId === record.productId;
          return (
            <Button
              type="primary"
              size="small"
              loading={isProcessing}
              disabled={isProcessing}
              onClick={() => this.handleResendClick(record)}
            >
              Resend
            </Button>
          );
        }
      }
    ];

    const { resendModalVisible, resendRecord, resendLoading } = this.state;

    return (
      <>
      <Layout style={{ minHeight: '100vh' }}>
        <ClientSider />
        <Layout>
          <ClientHeader />
          <Content style={{ margin: '24px 16px 0' }}>
            <Card>
              <Title level={3} style={{ marginBottom: '1rem' }}>
                <UserOutlined style={{ marginRight: 8 }} />
                AWS Marketplace Subscription User List
              </Title>
                 <Form 
                    ref={this.formRef} 
                    onFinish={this.handleFormChange}
                 >
                  <Row >
                    <Col span={12}>
                      <Form.Item label="Subscription Date" name="createdAt" >
                        <RangePicker format="YYYY-MM-DD" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Expires Date" name="expiresAt" >
                        <RangePicker format="YYYY-MM-DD" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Form.Item label="Subscription Plan" name="productCode" >
                      <Select
                        showSearch
                        style={{ width: 200 }}
                        optionFilterProp="label"
                        allowClear={true}
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                      >
                          {this.props.productList.map(item => (
                            <Select.Option key={item.productCode} label={item.producTitle}>
                              {item.producTitle}
                            </Select.Option>
                          ))}
                      </Select>
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Search
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item>
                        <Button type="primary" ghost onClick={this.handleFormReset}>
                          Reset
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <br/>
                <Table
                  dataSource={this.props.UserList}
                  rowKey={(record)=>{ return (record.subscriptionId)}}
                  columns={columns}
                  bordered
                  pagination={{ pageSize: 15 }}
                  showSorterTooltip={false} // 關閉所有排序提示
                />
            </Card>
          </Content>
          <ClientFooter />
        </Layout>
      </Layout>

      <Modal
        title="Resend Visibility Apply"
        open={resendModalVisible}
        onOk={this.handleResendConfirm}
        onCancel={this.handleResendCancel}
        confirmLoading={resendLoading}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>Are you sure you want to resend the visibility apply request?</p>
        {resendRecord && (
          <p>Product: <strong>{resendRecord.dimension}</strong></p>
        )}
      </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
   UserList: state.user.UserList,
   productList: state.user.productList,
   status: state.adminUser.status,
   message: state.adminUser.message
});

const mapDispatchToProps = {
  fetchUser,
  fetchSubscriptionPlanOption,
  resendVisibilityApply
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);